import { render } from "./IntentionSetterV1TextEmailSwitch.vue?vue&type=template&id=74cd072a&scoped=true"
import script from "./IntentionSetterV1TextEmailSwitch.vue?vue&type=script&lang=js"
export * from "./IntentionSetterV1TextEmailSwitch.vue?vue&type=script&lang=js"

import "./IntentionSetterV1TextEmailSwitch.vue?vue&type=style&index=0&id=74cd072a&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cd072a"]])

export default __exports__